export interface MarketingRuleTableRowData {
  index: number;
  defaultTransformation: boolean;
  positionData: boolean;
  marketingRule?: string;
  conditions?: string;
  trigger?: string;
  comment?: string;
}

export enum MarketingRuleTableContentColumn {
  defaultTransformation = "defaultTransformation",
  positionData = "positionData",
  marketingRule = "marketingRule",
  conditions = "conditions",
  trigger = "trigger",
  comment = "comment",
}
